<template>
	<div>
		<div class="table_head table_head_filter">
			<div class="tertiary_color text_left">
				{{ $t("investorsList.header") }}
			</div>
		</div>
		<div class="investor_table filter_table">
			<div class="md-card md-card-tabs card_table_box">
				<div class="md-card-content">
					<!-- unchecked investors 2-->
					<UncheckedTable
						:shuttleType="'unChecked'"
						:filters="filters"
						ref="unCheckedTable"
						v-on:getGridApi="getEnabledGridApi"
						v-on:einblenden="changeEinblenden"
					></UncheckedTable>
					<BtnGroup v-if="einblenden" :fistFun="addGroup" :secondFun="handeled" :groupType="2"></BtnGroup>
				</div>
			</div>
			<div class="flex w_100">
				<div class="md-card md-card-tabs card_table_box flex_1" style="width: 45%">
					<div class="md-card-content">
						<!-- excluded investors 3-->
						<ShuttleTable
							:shuttleType="'excluded'"
							:filters="filters"
							v-on:getGridApi="getEnabledGridApi"
							ref="excludedTable"
						></ShuttleTable>
					</div>
				</div>
				<BtnGroup :fistFun="addGroup" :secondFun="removeGroup" :groupType="1"></BtnGroup>
				<div class="md-card md-card-tabs card_table_box flex_1" style="width: 45%">
					<div class="md-card-content">
						<!-- enabled investors 1-->
						<ShuttleTable
							:shuttleType="'enabled'"
							:filters="filters"
							v-on:getGridApi="getEnabledGridApi"
							:noTableHeaderClass="true"
							ref="enabledTable"
						></ShuttleTable>
					</div>
				</div>
			</div>
			<ShuttleFilter @apply-filter="applyFilter"/>
		</div>
	</div>
</template>
<script>
import ShuttleTable from "@/components/templates/investorManagement/ShuttleTable.vue";
import BtnGroup from "src/components/templates/investorManagement/BtnGroup";
import {whitelistApi} from "@/common/api/whitelistApi";
import UncheckedTable from "@/components/templates/investorManagement/UncheckedTable.vue";
import ShuttleFilter from "@/components/templates/investorManagement/ShuttleFilter";


export default {
  components: { ShuttleFilter, ShuttleTable, BtnGroup,UncheckedTable },
  data() {
    return {
      rowData: [],
      filters: [],
      columnDefs: [],
      enabledApi: null,
      unCheckedApi: null,
      excludedApi: null,
      enabledData: [],
      unCheckedData: [],
      excludedData: [],
      einblenden:false
      // ids
    };
  },
  methods: {
    applyFilter(filters) {
        this.filters = filters;
    },
    changeEinblenden(einblenden){
     this.einblenden=einblenden
    },
    getEnabledGridApi(data) {
      switch (data.type) {
        case "enabled":
          // 1
          this.enabledApi = data.api;
          break;
        case "unChecked":
          // 2
          this.unCheckedApi = data.api;
          break;
        case "excluded":
          // 3
          this.excludedApi = data.api;
          break;
        default:
          break;
      }
    },
    addGroup(n) {
      // operation:0
      let checkList = [];
      if (n == 1) {
        // 2>1
        // unhandled>whitelisted
        var unCheckedSelect = this.unCheckedApi.getSelectedRows();
        unCheckedSelect.forEach(item => {
          this.$refs.unCheckedTable.rowData = this._.reject(
            this.$refs.unCheckedTable.rowData,
            item
          );
        });
        checkList = unCheckedSelect;
        this.modifyWhitelist(checkList, 0, "enabledTable", "unCheckedTable");
      } else {
        // 3>1
        // blacklisted >  whitelisted
        var excludedSelect = this.excludedApi.getSelectedRows();
        excludedSelect.forEach(item => {
          this.$refs.excludedTable.rowData = this._.reject(
            this.$refs.excludedTable.rowData,
            item
          );
        });
        checkList = excludedSelect;
        this.modifyWhitelist(checkList, 0, "enabledTable", "excludedTable");
      }

    },
    removeGroup() {
      // operation:1
      // whitelisted to blacklisted
      // 1 >3
      var enabledSelect = this.enabledApi.getSelectedRows();
      enabledSelect.forEach(item => {
        this.$refs.enabledTable.rowData = this._.reject(
          this.$refs.enabledTable.rowData,
          item
        );
      });
      this.modifyWhitelist(enabledSelect, 1, "excludedTable", "enabledTable");
    },
    handeled() {
      // unhandled to blacklisted
      // 2 > 3
      var unCheckedSelect = this.unCheckedApi.getSelectedRows();
      unCheckedSelect.forEach(item => {
        this.$refs.unCheckedTable.rowData = this._.reject(
          this.$refs.unCheckedTable.rowData,
          item
        );
      });
      this.modifyWhitelist(unCheckedSelect, 2, "excludedTable", "unCheckedTable");
      // operation:2
    },
    modifyWhitelist(list, operation, toType, fromType) {
      let option = {
        ids: [],
        operation: operation
      };
      if (list.length > 0) {
        list.forEach(item => {
          option.ids.push(item.id);
        });
      } else {
        return;
      }
      whitelistApi
        .modifyWhitelist(option)
        .then(res => {
          this.$refs[toType].getList();
          this.$refs[fromType].getList();
        })
        .catch(err => {
          this.toast(err);
        });
    }
  },
 
};
</script>

<style lang="scss" scoped>
.investor_table {
    .md-card.flex_1 {
        width: auto;
    }

	.filter_button_group {
		position: fixed;
		right: 0 !important;
		top: 210px !important;
	}

	.filter_box {
		position: fixed;
		right: 3rem !important;
		top: 190px !important;
	}
}

.card_table_box {
	box-shadow: 0 1px 8px 0 rgba(0,0,0,.20)
}

</style>
